
    <!-- <label class="form-label">{{ field.templateOptions.label }}</label> -->
    <div class="form-group">
      <input
        type="date"
        [formControl]="formControl"
        class="form-control"
        [formlyAttributes]="field"
        [min]="field.templateOptions._min"
        [max]="field.templateOptions._max"
      />
      <!--

      [min]="field.templateOptions.minDate"
        [max]="field.templateOptions.maxDate"
        [disabled]="field.templateOptions.disabled"
       -->
      <!-- <dp-date-picker
      [formControl]="formControl"
      [config]="field.templateOptions.config"
      ></dp-date-picker> -->
      <!-- <material-datepicker [(date)]="formControl"></material-datepicker> -->


    </div>
    <!-- {{ formControl | json }} -->
    <!-- {{ field | json }} -->
    <!-- [mode]="'month'"
                    [(ngModel)]="finished_at"
                    [placeholder]="'finished_at'"
                    [ngModelOptions]="{standalone: true}"
                    [config]="dpConfig"
                    (onChange)="filterChanged($event, 'finished_at');" -->
    <!-- <div
      [ngClass]="{
        'border-danger': formControl.errors && formControl.touched,
        disabled: field.templateOptions.disabled
      }"
      style="border: 1px solid transparent;
    padding: 0 0.1rem 0 0;"
    >
      <app-editor
        [elementId]="field.id"
        [dataForm]="formControl.value"
        [disabled]="field.templateOptions.disabled"
        (notify)="
          formControl.patchValue($event.id); formControl.markAsTouched()
        "
      ></app-editor>
    </div> -->
  